import { createContext, useContext, useState, type ReactNode } from 'react';
import type { Deal, Touchpoint } from '../types';
export type SyncStatus = 'idle' | 'loading' | 'success' | 'error' | 'never';
interface DealsCtxValue {
  deals: Deal[];
  setDeals: (deals: Deal[]) => void;
  touchpoints: Touchpoint[];
  setTouchpoints: (touchpoints: Touchpoint[]) => void;
  isLiveData: boolean;
  syncStatus: SyncStatus;
  lastSynced: string | null;
  setSyncMeta: (status: SyncStatus, lastSynced?: string | null) => void;
}
const DealsContext = createContext<DealsCtxValue>({
  deals: [],
  setDeals: () => {},
  touchpoints: [],
  setTouchpoints: () => {},
  isLiveData: false,
  syncStatus: 'idle',
  lastSynced: null,
  setSyncMeta: () => {}
});
export function useDeals(): DealsCtxValue {
  return useContext(DealsContext);
}
export function DealsProvider({
  children
}: {
  children: ReactNode;
}) {
  const [deals, setDealsState] = useState<Deal[]>([]);
  const [touchpoints, setTouchpointsState] = useState<Touchpoint[]>([]);
  const [isLiveData, setIsLiveData] = useState(false);
  const [syncStatus, setSyncStatusState] = useState<SyncStatus>('idle');
  const [lastSynced, setLastSynced] = useState<string | null>(null);
  const setDeals = (d: Deal[]) => {
    setDealsState(d);
    setIsLiveData(true);
  };
  const setTouchpoints = (t: Touchpoint[]) => {
    console.log('[DealsContext] setTouchpoints:', t.length, 'touchpoints');
    setTouchpointsState(t);
  };
  const setSyncMeta = (status: SyncStatus, ts?: string | null) => {
    setSyncStatusState(status);
    if (ts !== undefined) setLastSynced(ts ?? null);
  };
  return <DealsContext.Provider value={{
    deals,
    setDeals,
    touchpoints,
    setTouchpoints,
    isLiveData,
    syncStatus,
    lastSynced,
    setSyncMeta
  }} data-id="element-990" data-mp="75br0c8mn3t9">
      {children}
    </DealsContext.Provider>;
}